import React, { useState } from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import styles from '../Productos.module.scss';

interface ImageCarouselProps {
  imagenes: string[];
  nombre: string;
}

export const ImageCarousel: React.FC<ImageCarouselProps> = ({ imagenes, nombre }) => {
  const [current, setCurrent] = useState(0);

  const prev = (e: React.MouseEvent) => {
    e.stopPropagation();
    setCurrent(i => (i === 0 ? imagenes.length - 1 : i - 1));
  };

  const next = (e: React.MouseEvent) => {
    e.stopPropagation();
    setCurrent(i => (i === imagenes.length - 1 ? 0 : i + 1));
  };

  if (imagenes.length === 1) {
    return <img src={imagenes[0]} alt={nombre} className={styles.productos__image} loading="lazy" />;
  }

  return (
    <div className={styles.productos__carousel}>
      <img src={imagenes[current]} alt={`${nombre} ${current + 1}`} className={styles.productos__image} loading="lazy" />
      <button className={`${styles.productos__arrow} ${styles['productos__arrow--left']}`} onClick={prev}>
        <LeftOutlined />
      </button>
      <button className={`${styles.productos__arrow} ${styles['productos__arrow--right']}`} onClick={next}>
        <RightOutlined />
      </button>
      <div className={styles.productos__dots}>
        {imagenes.map((_, i) => (
          <span
            key={i}
            className={`${styles.productos__dot} ${i === current ? styles['productos__dot--active'] : ''}`}
            onClick={() => setCurrent(i)}
          />
        ))}
      </div>
    </div>
  );
};